import Item from './detail'
import listComponent from '@/util/proto/listComponent'
import LicenseSelect from '../../license/partial/license-select'

const state = [{value:1 , label:'已发布'},{value:0 , label:'未发布'}]

const displayLicense = (d) => {
  return (d.licenses || []).map(i => i.name).join(';')
}

export default {
  extends: listComponent,
  data() {
    return {
      columns: [
        
        {
          title: '模板编号',
          key: 'code',
          width:100
        },
        {
          title: '模板名称',
          key: 'name',
          minWidth:150
        },
        {
          title: '总分',
          key: 'totalScore',
          minWidth:90
        },
        {
          title: '分数线',
          key: 'passScore',
          minWidth:90
        },
        {
          title:'适用证照',
          key:'displayLicense',
          minWidth:200,
        },
        /*{
          title: '所属机构',
          key: 'organizeName',
          minWidth:120
        },*/
        {
          title: '创建时间',
          key: 'createDatetimeText',
          minWidth:150
        },
        {
          title: '状态',
          key: 'stateText',
          minWidth:100
        },
        {
          title: '操作',
          key: 'action',
          width: 120,
          align: 'center',
          fixed: 'right',
          render: (h, {row}) => {
            const node = [
              <a v-permission="exam.tpl.update" on-click={()=>this.edit(row)}>编辑</a>,
              <a v-permission="exam.tpl.delete" on-click={()=>this.remove(row)}>删除</a>
            ]
            return this.$utils.link(node,<Divider type="vertical" />)
          }
        }
      ],
      data: [],
      params: {
        name: null,
        licenseId : null,
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
    }
  },
  created() {
    this.def = { ...this.params }
    this.search()
  },

  methods: {
    search() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.examTpls(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [] , {'templateType':'$examTplType' , 'createDatetime':'datetime' , 'state':'$state',displayLicense})
          this.page.total = resp.data.total || 0
        }
      })
    },

    edit(row) {
      this.$refs['item'].init(row.id)
    },

    create() {
      this.$refs['item'].init()
    },

    remove(row) {
      this.$ui.confirm(this.$request.examTplDelete, `确定删除 ${row.name} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.list()
        }else{
          this.$Message.error(resp.msg)
        }
      })
    },

    view(row){

    },

    reset() {
      this.$utils.fill(this.params, this.def)
      this.search()
    },

    handleUpdate() {
      this.search()
    },
  },
  render(){
    return <sl-page>
        <div class="page-filter">
          <sl-search on-search={this.search} on-reset={this.reset}>
            <sl-search-item label="">
              <i-input v-model={this.params.name} placeholder="模板名称" />
            </sl-search-item>
            <sl-search-item label="">
              <LicenseSelect multiple={false} v-model={this.params.licenseId} />
            </sl-search-item>
            <template slot="action">
              <Button v-permission="exam.tpl.insert" type="primary" icon="md-add" on-click={this.create}>新增</Button>
            </template>
          </sl-search>
        </div>
        <div class="pg-bd">
          <sl-table showHeader={true} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange}>
          </sl-table>
        </div>
        <Item ref="item" on-update={this.handleUpdate} />
      </sl-page>
  }
}